/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkIcon16Regular = forwardRef('AttachLinkIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M.25 8A4.75 4.75 0 0 1 5 3.25h1.25a.75.75 0 0 1 0 1.5H5a3.25 3.25 0 1 0 0 6.5h1.25a.75.75 0 0 1 0 1.5H5A4.75 4.75 0 0 1 .25 8Z" }),
        React.createElement("path", { d: "M15.75 8A4.75 4.75 0 0 0 11 3.25H9.75a.75.75 0 0 0 0 1.5H11a3.25 3.25 0 0 1 0 6.5H9.75a.75.75 0 0 0 0 1.5H11A4.75 4.75 0 0 0 15.75 8Z" }),
        React.createElement("path", { d: "M4.75 7.25a.75.75 0 0 0 0 1.5h6.5a.75.75 0 0 0 0-1.5h-6.5Z" })));
});
